// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zJhbI","content":"Card_content__NyrPM","img":"Card_img__kO7-Z","badge":"Card_badge__Rmplc"};